export const getClientOrganizationByOrganization = /* GraphQL */ `
  query GetClientOrganizationByOrganization(
    $organizationId: ID
    $clientId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelClientOrganizationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getClientOrganizationByOrganization(
      organizationId: $organizationId
      clientId: $clientId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        organizationId
        clientId
        client {
          id
          type
          isActive
          name
          dba
        }
      }
      nextToken
    }
  }
`;
